"use client";

import { useParams, useRouter } from "next/navigation";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AdminBreadcrumb, AdminTitle } from "@/shared";
import {
  adminArticleCreate,
  ArticleStates,
  AdminArticlePath,
  AdminArticleTitle,
} from "@/entities";
import {
  AdminArticleListButton,
  AdminCommonFileCoverWrite,
  AdminCommonFileFilesWrite,
} from "@/features";
import { AdminArticleForm } from "./ArticleForm";
import moment from "moment";

export function AdminArticleNewPage() {
  const router = useRouter();
  const params = useParams<{ slug: string }>();
  const slug = params?.slug || "";

  const timestamp = new Date().getTime().toString();

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      state: ArticleStates[0].key,
      common_category_id: "",
      title: "",
      desc: "",
      cover: null,
      files: [],
      created_at: moment().format("YYYY-MM-DD"),
    },
  });

  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: adminArticleCreate,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`admin-articles`, { slug, page: 1, perPage: 15 }],
      });
      toast.success("글정보가 등록되었습니다.");
      router.push(`/admin/${slug}`);
    },
    onError: (e: any) => {
      toast.error(`에러(${e.message})가 발생했습니다. 다시 시도해 주세요.`);
    },
  });
  const onSubmit = async (data: any) => {
    if (createMutation.isPending) return;
    await createMutation.mutateAsync({ ...data, timestamp, slug });
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <AdminBreadcrumb items={AdminArticlePath} />
          <AdminTitle title={AdminArticleTitle} />
        </div>
        <div className="ms-auto">
          <AdminArticleListButton />
        </div>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-4">
            <AdminCommonFileCoverWrite
              panelTitle="커버 이미지"
              name="cover"
              control={control}
              defaultValue={watch("cover")}
              setValue={setValue}
              accept="image/*"
            />
          </div>
          <div className="col-md-8">
            <AdminCommonFileFilesWrite
              panelTitle="첨부파일"
              name="files"
              control={control}
              defaultValue={watch("files")}
              setValue={setValue}
              // accept="image/*"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <AdminArticleForm
              panelTitle="글정보"
              control={control}
              errors={errors}
              watch={watch}
              setValue={setValue}
              timestamp={timestamp}
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-4 text-left">
            <AdminArticleListButton />
          </div>
          <div className="col-4 text-center">
            <button type="submit" className="btn btn-inverse">
              <i className="fa fa-check" />
              <span> 저장</span>
            </button>
          </div>
          <div className="col-4 text-right"></div>
        </div>
      </form>
    </>
  );
}
